import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";


const SecondEducation: FC = () => {
  return (
    <Box mt={1}>
      <Header>
        <Box display='flex'>
          <TextField
            label="Учебное заведение"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Номер диплома"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "300px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Дата окончания"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ mr: 38, mb: 1, width: "204px"}}
          />
          <TextField
            label="Дата выдачи"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "200px", mr: 1 }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Факультет"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "500px" }}
          />
          <TextField
            label="Форма обучения"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "300px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Специальность по диплому"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Код специальности по ОКСО"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "500px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Полное наименование специальности"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 1, width: "800px" }}
          />
        </Box>
        <Box display='flex'>
          <TextField
            label="Квалификация по диплому"
            variant="outlined"
            size="small"
            sx={{ mr: 1, mb: 10, width: "800px" }}
          />
        </Box>
      </Header>
      <Body>
        <Typography sx={{mb: 1, ml: 1}}> Дополнительное образование до приема на работу: </Typography>
        <TextField
          label="повышение квалификации"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 2 }}
        />
        <TextField
          label="освоение других профессий"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 5 }}
        />
      </Body>
    </Box>
  );
};

export default SecondEducation;
